import moment from 'moment';

const mock = [
  {
    field: 'preco',
    valueGetter: ({ value }) =>
      value &&
      value?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }),
  },
  {
    field: 'margem',
    valueGetter: ({ value }) =>
      value &&
      value?.toLocaleString('pt-br', { minimumFractionDigits: 2 }) + '%',
  },
  {
    field: 'status',
    renderCell: ({ value }) => (
      <div style={colorContainer(value)}>
        <span>{value}</span>
      </div>
    ),
  },
];

const colorContainer = (value) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: value === 'ATIVO' ? '#baffc9' : '#ffb3ba',
});

export default mock;
